module.exports = __webpack_public_path__ + "static/hero-travel-loan-b5279f530475bbc5db4bc2ec0eb73a17.webp";